module.exports = __webpack_public_path__ + "media/images/cart/cart_btn04_ov-e60c93f2cf81ecb61de49b192c521971.gif";